import { toast } from 'react-toastify';

function ensureMessageString(input) {
    if (input == null) return ' ';
    if (typeof input === 'string') return input || ' ';
    if (typeof input === 'object') {
        const candidates = [
            input.message,
            input.error,
            input.detail,
            input.description,
            input.details,
            input.payload && input.payload.message,
            input.payload && input.payload.error
        ];
        const first = candidates.find((v) => typeof v === 'string' && v.trim().length);
        if (first) return first;
        if (input.code && input.message) return `${input.message} (Code: ${input.code})`;
        try { return JSON.stringify(input); } catch(e) { return String(input); }
    }
    return String(input);
}

function fallbackByType(type) {
    switch (type) {
        case 'error': return 'Error';
        case 'info': return 'Info';
        case 'warning': return 'Warning';
        case 'success':
        default: return 'Success';
    }
}

const defaultOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
};

const CustomNotify = (message = '', type = 'success', params = {}) => {
    let formattedMessage = ensureMessageString(message);
    if (!formattedMessage || !String(formattedMessage).trim()) {
        formattedMessage = fallbackByType(type);
    }
    const opts = { ...defaultOptions, ...(params || {}) };

    switch (type) {
        case 'error':
            return toast.error(formattedMessage, opts);
        case 'info':
            return toast.info(formattedMessage, opts);
        case 'warning':
            return toast.warning(formattedMessage, opts);
        case 'success':
        default:
            return toast.success(formattedMessage, opts);
    }
};

export default CustomNotify;
